import React, {useEffect, useState} from 'react'

import {initializeApp} from 'firebase/app'
import {getDatabase, ref, onValue} from 'firebase/database'
import axios from 'axios'
import {toast} from 'react-toastify'

export function RevenueV2() {

  const firebaseConfig = JSON.parse(`${process.env.REACT_APP_FIREBASE_CONFIG}`)

  const [loading, setLoading] = useState(false)

  const [revenue, setRevenue] = useState<any>(null)
  const [updateTime, setUpdateTime] = useState('')
  const app = initializeApp(firebaseConfig)
  const database = getDatabase(app)
  const starCountRef = ref(database, 'admin/revenue')

  useEffect(() => {
    return onValue(starCountRef, (snapshot) => {
      const data = snapshot.val()
      console.log(data)
      setRevenue(data)
      setUpdateTime(data.updated_at)
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const update = () => {

    setLoading(true)

      axios
        .get(`${process.env.REACT_APP_API2_URL}firebase/paid/update/new`)
        .then(({data: {error, result}}) => {
          console.log(error)
          console.log(result)
          setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          setLoading(false)
        })
  }

  return (
<>
    <div style={{
      position: 'fixed',
      width: '100%',
      height: '100%',
      backgroundColor: 'white',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10000,
      padding: 20,
      overflowY: 'auto'
    }}>

      <p style={{
        fontSize: 14,
        width: '100%',
        maxWidth: '1920px',
        margin: '20px auto'
      }}>
        Updated : {updateTime}
      </p>

      {
        revenue &&
        <>
          <h2 style={{width: '100%', maxWidth: '1920px', margin: '5px auto'}}>연 매출</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse', maxWidth: '1920px', margin: 'auto' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '20%' }}>항목</th>
                <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '27%' }}>{revenue.totalYPreDate}</th>
                <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '27%' }}>{revenue.totalYDate}</th>
                <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '26%' }}>Y/Y</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>플레이스</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesPre).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSales).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalYSalesPre === 0 || revenue.totalYSales === 0) ? 'black' : revenue.totalYSalesPercent < 0 ? 'blue' : 'red'}}>
                  { (revenue.totalYSalesPre === 0 || revenue.totalYSales === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.totalYSalesPercent < 0 ? `▼` : `▲`} {revenue.totalYSalesPercent > 0 ? '+' : ''}{revenue.totalYSalesPercent}%
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>장비</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesEquipmentPre).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesEquipment).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalYSalesEquipmentPre === 0 || revenue.totalYSalesEquipment === 0) ? 'black' : revenue.totalYSalesEquipmentPercent < 0 ? 'blue' : 'red'}}>
                  { (revenue.totalYSalesEquipmentPre === 0 || revenue.totalYSalesEquipment === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.totalYSalesEquipmentPercent < 0 ? `▼` : `▲`} {revenue.totalYSalesEquipmentPercent > 0 ? '+' : ''}{revenue.totalYSalesEquipmentPercent}%
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>광고</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYAdvPre).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYAdv).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalYAdvPre === 0 || revenue.totalYAdv === 0) ? 'black' : revenue.totalYAdvPercent < 0 ? 'blue' : 'red'}}>
                  { (revenue.totalYAdvPre === 0 || revenue.totalYAdv === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.totalYAdvPercent < 0 ? `▼` : `▲`} {revenue.totalYAdvPercent > 0 ? '+' : ''}{revenue.totalYAdvPercent}%
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 플레이스</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesNaverPre).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesNaver).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalYSalesNaverPre === 0 || revenue.totalYSalesNaver === 0) ? 'black' : revenue.totalYSalesNaverPercent < 0 ? 'blue' : revenue.totalYSalesNaverPre === 0 ? 'black' : 'red'}}>
                  { (revenue.totalYSalesNaverPre === 0 || revenue.totalYSalesNaver === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.totalYSalesNaverPercent < 0 ? `▼` : revenue.totalYSalesNaverPre === 0 ? '' : `▲`} {revenue.totalYSalesNaverPercent > 0 ? '+' : ''}{revenue.totalYSalesNaverPercent}%
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 장비</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesEquipmentNaverPre).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalYSalesEquipmentNaver).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalYSalesEquipmentNaverPre === 0 || revenue.totalYSalesEquipmentNaver === 0) ? 'black' : revenue.totalYSalesEquipmentNaverPercent < 0 ? 'blue' : revenue.totalYSalesEquipmentNaverPre === 0 ? 'black' : 'red'}}>
                  { (revenue.totalYSalesEquipmentNaverPre === 0 || revenue.totalYSalesEquipmentNaver === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.totalYSalesEquipmentNaverPercent < 0 ? `▼` : revenue.totalYSalesEquipmentNaverPre === 0 ? '' : `▲`} {revenue.totalYSalesEquipmentNaverPercent > 0 ? '+' : ''}{revenue.totalYSalesEquipmentNaverPercent}%
                    </>
                  )}
                </td>
              </tr>
              <tr style={{fontWeight: 'bold'}}>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>합계</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.yearPreTotal).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.yearTotal).toLocaleString('en')}</td>
                <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.yearPreTotal === 0 || revenue.yearTotal === 0) ? 'black' : revenue.yearTotalPercent < 0 ? 'blue' : 'red'}}>
                  { (revenue.yearPreTotal === 0 || revenue.yearTotal === 0) ? (
                    '-%'
                  ) : (
                    <>
                      {revenue.yearTotalPercent < 0 ? `▼` : `▲`} {revenue.yearTotalPercent > 0 ? '+' : ''}{revenue.yearTotalPercent}%
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <br/>
          <br/>
          <br/>
          <h2 style={{width: '100%', maxWidth: '1920px', margin: '5px auto'}}>월 매출</h2>
          <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', maxWidth: '1920px', margin: 'auto' }}>
            <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '10%' }}>항목</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>{revenue.totalMDateYPre}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>{revenue.totalMDatePre}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>{revenue.totalMDate}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>M/M</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>Y/Y</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '15%' }}>{revenue.totalMDateMNext}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>플레이스</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesYPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSales).toLocaleString('en')} ~ {Number(revenue.totalMBookings).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesPre === 0 || revenue.totalMSales === 0) ? 'black' : revenue.totalMSalesMPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMSalesPre === 0 || revenue.totalMSales === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesMPercent < 0 ? `▼` : `▲`} {revenue.totalMSalesMPercent > 0 ? '+' : ''}{revenue.totalMSalesMPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSales === 0 || revenue.totalMSalesYPre === 0) ? 'black' : revenue.totalMSalesYPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMSales === 0 || revenue.totalMSalesYPre === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesYPercent < 0 ? `▼` : `▲`} {revenue.totalMSalesYPercent > 0 ? '+' : ''}{revenue.totalMSalesYPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesMNext).toLocaleString('en')}</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>장비</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentYPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipment).toLocaleString('en')} ~ {Number(revenue.totalMBookingEquipments).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesEquipment === 0 || revenue.totalMSalesEquipmentPre === 0) ? 'black' : revenue.totalMSalesEquipmentMPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMSalesEquipment === 0 || revenue.totalMSalesEquipmentPre === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesEquipmentMPercent < 0 ? `▼` : `▲`} {revenue.totalMSalesEquipmentMPercent > 0 ? '+' : ''}{revenue.totalMSalesEquipmentMPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesEquipment === 0 || revenue.totalMSalesEquipmentYPre === 0) ? 'black' : revenue.totalMSalesEquipmentYPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMSalesEquipment === 0 || revenue.totalMSalesEquipmentYPre === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesEquipmentYPercent < 0 ? `▼` : `▲`} {revenue.totalMSalesEquipmentYPercent > 0 ? '+' : ''}{revenue.totalMSalesEquipmentYPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentMNext).toLocaleString('en')}</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>광고</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMAdvYPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMAdvPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMAdv).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMAdvPre === 0 || revenue.totalMAdv === 0) ? 'black' : revenue.totalMAdvMPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMAdvPre === 0 || revenue.totalMAdv === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMAdvMPercent < 0 ? `▼` : `▲`} {revenue.totalMAdvMPercent > 0 ? '+' : ''}{revenue.totalMAdvMPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMAdvYPre === 0 || revenue.totalMAdv === 0) ? 'black' : revenue.totalMAdvYPercent < 0 ? 'blue' : 'red'}}>
                { (revenue.totalMAdvYPre === 0 || revenue.totalMAdv === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMAdvYPercent < 0 ? `▼` : `▲`} {revenue.totalMAdvYPercent > 0 ? '+' : ''}{revenue.totalMAdvYPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMAdvMNext).toLocaleString('en')}</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 플레이스</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesNaverYPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesNaverPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesNaver).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesNaverPre === 0 || revenue.totalMSalesNaver === 0) ? 'black' : revenue.totalMSalesNaverMPercent < 0 ? 'blue' : revenue.totalMSalesNaverMPercent === '-' ? 'black' :'red'}}>
                { (revenue.totalMSalesNaverPre === 0 || revenue.totalMSalesNaver === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesNaverMPercent < 0 ? `▼` : revenue.totalMSalesNaverMPercent === '-' ? '' : `▲`} {revenue.totalMSalesNaverMPercent > 0 ? '+' : ''}{revenue.totalMSalesNaverMPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesNaverYPre === 0 || revenue.totalMSalesNaver === 0) ? 'black' : revenue.totalMSalesNaverYPercent < 0 ? 'blue' :  revenue.totalMSalesNaverYPercent === '-' ? 'black' : 'red'}}>
                { (revenue.totalMSalesNaverYPre === 0 || revenue.totalMSalesNaver === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesNaverYPercent < 0 ? `▼` :  revenue.totalMSalesNaverYPercent === '-' ? '' : `▲`} {revenue.totalMSalesNaverYPercent > 0 ? '+' : ''}{revenue.totalMSalesNaverYPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesNaverMNext).toLocaleString('en')}</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 장비</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentNaverYPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentNaverPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentNaver).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesEquipmentNaverPre === 0 || revenue.totalMSalesEquipmentNaver === 0) ? 'black' : revenue.totalMSalesEquipmentNaverMPercent < 0 ? 'blue' : revenue.totalMSalesEquipmentNaverMPercent === '-' ? 'black' :'red'}}>
                { (revenue.totalMSalesEquipmentNaverPre === 0 || revenue.totalMSalesEquipmentNaver === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesEquipmentNaverMPercent < 0 ? `▼` : revenue.totalMSalesEquipmentNaverMPercent === '-' ? '' : `▲`} {revenue.totalMSalesEquipmentNaverMPercent > 0 ? '+' : ''}{revenue.totalMSalesEquipmentNaverMPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalMSalesEquipmentNaverYPre === 0 || revenue.totalMSalesEquipmentNaver === 0) ? 'black' : revenue.totalMSalesEquipmentNaverYPercent < 0 ? 'blue' :  revenue.totalMSalesEquipmentNaverYPercent === '-' ? 'black' : 'red'}}>
                { (revenue.totalMSalesEquipmentNaverYPre === 0 || revenue.totalMSalesEquipmentNaver === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalMSalesEquipmentNaverYPercent < 0 ? `▼` :  revenue.totalMSalesEquipmentNaverYPercent === '-' ? '' : `▲`} {revenue.totalMSalesEquipmentNaverYPercent > 0 ? '+' : ''}{revenue.totalMSalesEquipmentNaverYPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalMSalesEquipmentNaverMNext).toLocaleString('en')}</td>
            </tr>
            <tr style={{fontWeight: 'bold'}}>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>합계</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.monthTotalYPreMonth).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.monthTotalPreMonth).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.monthTotalMonth).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.monthTotalPreMonth === 0 || revenue.monthTotalMonth === 0) ? 'black' : revenue.monthTotalMonthPercent < 0 ? 'blue' : revenue.monthTotalMonthPercent === '-' ? 'black' :'red'}}>
                { (revenue.monthTotalPreMonth === 0 || revenue.monthTotalMonth === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.monthTotalMonthPercent < 0 ? `▼` : revenue.monthTotalMonthPercent === '-' ? '' : `▲`} {revenue.monthTotalMonthPercent > 0 ? '+' : ''}{revenue.monthTotalMonthPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.monthTotalYPreMonth === 0 || revenue.monthTotalMonth === 0) ? 'black' : revenue.monthTotalYearPercent < 0 ? 'blue' :  revenue.monthTotalYearPercent === '-' ? 'black' : 'red'}}>
                { (revenue.monthTotalYPreMonth === 0 || revenue.monthTotalMonth === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.monthTotalYearPercent < 0 ? `▼` :  revenue.monthTotalYearPercent === '-' ? '' : `▲`} {revenue.monthTotalYearPercent > 0 ? '+' : ''}{revenue.monthTotalYearPercent}%
                  </>
                )}
              </td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.monthTotalMonthNext).toLocaleString('en')}</td>
            </tr>
            </tbody>
          </table>
          </div>
          <br/>
          <br/>
          <br/>
          <h2 style={{width: '100%', maxWidth: '1920px', margin: '5px auto'}}>일 매출</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse', maxWidth: '1920px', margin: 'auto' }}>
            <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '20%' }}>항목</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '30%' }}>{revenue.totalDDatePre}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '30%' }}>{revenue.totalDDate}</th>
              <th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f2f2f2', textAlign: 'center', width: '20%' }}>D/D</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>플레이스</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesPaidPre).toLocaleString('en')}({Number(revenue.totalDSalesPre).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesPaid).toLocaleString('en')}({Number(revenue.totalDSales).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalDSalesPaidPre === 0 || revenue.totalDSalesPaid === 0) ? 'black' : revenue.totalDSalesPaidPercent < 0 ? 'blue' : revenue.totalDSalesPaidPercent === '-' || revenue.totalDSalesPaidPercent === 0 ? 'black' :'red'}}>
                { (revenue.totalDSalesPaidPre === 0 || revenue.totalDSalesPaid === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDSalesPaidPercent < 0 ? `▼` : revenue.totalDSalesPaidPercent === '-' ? '' : revenue.totalDSalesPaidPercent === 0 ? '' : `▲`} {revenue.totalDSalesPaidPercent > 0 ? '+' : ''}{revenue.totalDSalesPaidPercent}%
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>장비</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesEquipmentPaidPre).toLocaleString('en')}({Number(revenue.totalDSalesEquipmentPre).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesEquipmentPaid).toLocaleString('en')}({Number(revenue.totalDSalesEquipment).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalDSalesEquipmentPaidPre === 0 || revenue.totalDSalesEquipmentPaid === 0) ? 'black' : revenue.totalDSalesEquipmentPaidPercent < 0 ? 'blue' : revenue.totalDSalesEquipmentPaidPercent === '-' || revenue.totalDSalesEquipmentPaidPercent === 0 ? 'black' :'red'}}>
                { (revenue.totalDSalesEquipmentPaidPre === 0 || revenue.totalDSalesEquipmentPaid === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDSalesEquipmentPaidPercent < 0 ? `▼` : revenue.totalDSalesEquipmentPaidPercent === '-' ? '' : revenue.totalDSalesEquipmentPaidPercent === 0 ? '' : `▲`} {revenue.totalDSalesEquipmentPaidPercent > 0 ? '+' : ''}{revenue.totalDSalesEquipmentPaidPercent}%
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>광고</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDAdvPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDAdv).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalDAdvPre === 0 || revenue.totalDAdv === 0) ? 'black' : revenue.totalDAdvPercent < 0 ? 'blue' : revenue.totalDAdvPercent === '-' || revenue.totalDAdvPercent === 0 ? 'black' :'red'}}>
                { (revenue.totalDAdvPre === 0 || revenue.totalDAdv === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDAdvPercent < 0 ? `▼` : revenue.totalDAdvPercent === '-' ? '' : revenue.totalDAdvPercent === 0 ? '' : `▲`} {revenue.totalDAdvPercent > 0 ? '+' : ''}{revenue.totalDAdvPercent}%
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 플레이스</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesNaverPaidPre).toLocaleString('en')}({Number(revenue.totalDSalesNaverPre).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesNaverPaid).toLocaleString('en')}({Number(revenue.totalDSalesNaver).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalDSalesNaverPaidPre === 0 || revenue.totalDSalesNaverPaid === 0) ? 'black' : revenue.totalDSalesPaidNaverPercent < 0 ? 'blue' : revenue.totalDSalesPaidNaverPercent === '-' || revenue.totalDSalesPaidNaverPercent === 0 ? 'black' :'red'}}>
                { (revenue.totalDSalesNaverPaidPre === 0 || revenue.totalDSalesNaverPaid === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDSalesPaidNaverPercent < 0 ? `▼` : revenue.totalDSalesPaidNaverPercent === '-' ? '' : revenue.totalDSalesPaidNaverPercent === 0 ? '' : `▲`} {revenue.totalDSalesPaidNaverPercent > 0 ? '+' : ''}{revenue.totalDSalesPaidNaverPercent}%
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>네이버 장비</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesEquipmentNaverPaidPre).toLocaleString('en')}({Number(revenue.totalDSalesEquipmentNaverPre).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.totalDSalesEquipmentNaverPaid).toLocaleString('en')}({Number(revenue.totalDSalesEquipmentNaver).toLocaleString('en')})</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.totalDSalesEquipmentNaverPaidPre === 0 || revenue.totalDSalesEquipmentNaverPaid === 0) ? 'black' : revenue.totalDSalesEquipmentPaidNaverPercent < 0 ? 'blue' : revenue.totalDSalesEquipmentPaidNaverPercent === '-' || revenue.totalDSalesEquipmentPaidNaverPercent === 0 ? 'black' :'red'}}>
                { (revenue.totalDSalesEquipmentNaverPaidPre === 0 || revenue.totalDSalesEquipmentNaverPaid === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDSalesEquipmentPaidNaverPercent < 0 ? `▼` : revenue.totalDSalesEquipmentPaidNaverPercent === '-' ? '' : revenue.totalDSalesEquipmentPaidNaverPercent === 0 ? '' : `▲`} {revenue.totalDSalesEquipmentPaidNaverPercent > 0 ? '+' : ''}{revenue.totalDSalesEquipmentPaidNaverPercent}%
                  </>
                )}
              </td>
            </tr>
            <tr style={{fontWeight: 'bold'}}>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'center'}}>합계</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.dayTotalDayPre).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right'}}>{Number(revenue.dayTotalDay).toLocaleString('en')}</td>
              <td style={{border: '1px solid #ccc', padding: '8px', textAlign: 'right', color: (revenue.dayTotalDayPre === 0 || revenue.dayTotalDay === 0) ? 'black' : revenue.totalDayTotalDayPercent < 0 ? 'blue' : revenue.totalDayTotalDayPercent === '-' || revenue.totalDayTotalDayPercent === 0 ? 'black' :'red'}}>
                { (revenue.dayTotalDayPre === 0 || revenue.dayTotalDay === 0) ? (
                  '-%'
                ) : (
                  <>
                    {revenue.totalDayTotalDayPercent < 0 ? `▼` : revenue.totalDayTotalDayPercent === '-' ? '' : revenue.totalDayTotalDayPercent === 0 ? '' : `▲`} {revenue.totalDayTotalDayPercent > 0 ? '+' : ''}{revenue.totalDayTotalDayPercent}%
                  </>
                )}
              </td>
            </tr>
            </tbody>
          </table>

          <div style={{width: '100%', margin: '50 auto', height: '80px', display: "flex", justifyContent: "center", alignItems: "center"}}>
            <label
              style={{ width:100, textAlign: "center", fontWeight: 'bold'}}
              onClick={() => {
                update()
              }}
              className='btn btn-primary'
            >
              {loading ? (
                <span className='spinner-border spinner-border-sm align-middle' />
              ) : (`HIT`)}
            </label>
          </div>
        </>
      }
      </div>
    </>
  )
}
